export enum InvoiceType {
    COURSE_PARTICIPATION = 'COURSE_PARTICIPATION',
    COURSE_PARTICIPATION_EXTENSION = 'COURSE_PARTICIPATION_EXTENSION',
    EXAM_PARTICIPATION = 'EXAM_PARTICIPATION',
    COURSE_PARTICIPATION_CORRECTION = 'COURSE_PARTICIPATION_CORRECTION',
}
